<div fxLayoutGap="24px" fxLayout="column" fxLayoutAlign="start center" mat-dialog-content>

  <img src="../../assets/images/logos/ls-premium.png"
       alt="Little SIS Premium logo" class="logo">

  <div fxLayout="column" [ngClass] = "{'red-600-fg': templateData.showIcon}"
       fxLayoutAlign="start center" class="license-info-panel">
    <div fxLayout="row"  fxLayoutAlign="center center" fxLayoutGap="16px">
      <mat-icon *ngIf="templateData.showIcon" class="icon-20">warning</mat-icon>
      <p class="center-text" [innerHTML]="templateData.expiryMessage | safe: 'html'"></p>
    </div>
    <div>{{templateData.expireDate}}</div>
  </div>

  <div fxLayout="row"  fxLayoutAlign="center center" fxLayoutGap="16px">
    <mat-card appearance="outlined" class="mat-elevation-z4 licensing-info">
      <mat-card-content fxLayout="column" fxLayoutAlign="start center">
        <p>
          Please note, if your trial does not move to a paid license on or before the above expiration date, your data will be deleted and you will no longer have access to Little SIS Premium.
          If you would like to delete your data sooner please contact support.
        </p>
        <div fxLayout="row"
             fxLayoutAlign="start center"
             fxLayoutGap="24px">
          <button #trialLimitsButton
                  class="renew-button"
                  mat-raised-button
                  (click)="showTrialLimits()">TRIAL LIMITS</button>

          <button class="renew-button"
                  mat-raised-button
                  (click)="requestSupport(templateData.domain)">CONTACT SUPPORT</button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

</div>

<div [fxLayoutAlign]="(templateData.expireDays > 7) ? 'space-between center':'end center'" mat-dialog-actions>
  <mat-checkbox *ngIf="templateData.expireDays > 7"  (change)="toggleReminder($event)" [(ngModel)]="muteNotification">Do not show me this again</mat-checkbox>
  <button mat-raised-button class="grey-button" (click)="closeDialog()">{{muteNotification ? 'SAVE & CLOSE' : 'CLOSE'}}</button>
</div>
